import axiosGlobal from '@/shared/plugins/axios-global';

export function useAxios() {
  return {
    axiosGlobal,
  };
}
